export class UserLicensedModel {
  allLicensed: number;
  unUsedLicensed: number;

  constructor() {
    this.allLicensed = 0;
    this.unUsedLicensed = 0;
  }
}
